import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLink = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "m4.25 9.75-1.257 1.257c-.07.07-.105.105-.138.14a4 4 0 0 0-1.104 2.665l-.001.195c0 .226 0 .338.005.434a4 4 0 0 0 3.804 3.804c.096.005.208.005.434.005l.195-.001a4 4 0 0 0 2.665-1.104c.035-.033.07-.068.14-.138l2.257-2.257c.16-.16.239-.239.303-.31a4 4 0 0 0 0-5.38 10.04 10.04 0 0 0-.303-.31L11 8.5m4.75 1.75 1.257-1.257c.07-.07.105-.105.138-.14a4 4 0 0 0 1.104-2.665l.001-.195c0-.226 0-.338-.005-.434a4 4 0 0 0-3.805-3.804c-.095-.005-.207-.005-.433-.005l-.195.001a4 4 0 0 0-2.805 1.242L8.75 5.25c-.16.16-.239.239-.303.31a4 4 0 0 0 0 5.38c.064.071.144.15.303.31l.25.25"
	})]
});
const ForwardRef = forwardRef(SvgLink);
export { ForwardRef as ReactComponent };
